import { render } from "./AboutS5.vue?vue&type=template&id=5f742540&scoped=true"
import script from "./AboutS5.vue?vue&type=script&lang=js"
export * from "./AboutS5.vue?vue&type=script&lang=js"

import "./AboutS5.vue?vue&type=style&index=0&id=5f742540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f742540"]])

export default __exports__